import curry1 from "ramda/src/internal/_curry1";
import _isArray from "ramda/src/internal/_isArray";
import isFunction from "./isFunction";

const isArray = curry1(isFunction(Array.isArray) ? Array.isArray : _isArray);

export default isArray;
